<p>department-stock works!</p>
